/**
 * UI element: Drag and drop file upload inteface
 * requires: jquery, s-ui-filedrop css file
 */
var springSpace = springSpace || {};
springSpace.sui = springSpace.sui || {};

/**
 * Constructor
 * @param {Object} config Configuration object
 * @param {String} config.selector Selector for the form that contains the filedrop
 * @param {Function} config.callback Success callback for the form submission
 * @param {Function} [config.error_callback] Error callback for the form submission
 * @param {Function} [config.validate] Validation to be called on form submission
 * @param {Number} [config.max_files=0] maximum number of uploads allowed 0=unlimited
 * @param {Number} [config.max_upload_size=0] maximum bytes you can upload to the server at once (probably set in nginx or php or both) 0=unlimited (i.e. don't check)
 * @param {Number} [config.max_file_size=0] maximum bytes for a single file 0=unlimited (i.e. don't check)
 * @param {Boolean} [config.batch_files=false] should files be batched and uploaded in groups if they exceed the max_upload_size
 * @param {Boolean} [config.autoupload=true] automatically submit the form when a file is dropped/added
 * @param {Object} [config.translations] Language values for various messages.
 * @param {Array} [config.allowedMimeTypes] Mime types of files that are allowed. Empty/unset means any.
 * @param {Array} [config.allowedFileExtensions] File extensions that are allowed. Empty/unset means any.
 * @return {Object}
 */
springSpace.sui.filedrop = function(config) {
    if (typeof config === 'undefined') { return false; }
    if (!config.selector || config.selector === '') { return false; }

    let defaultTranslations = {
        max_file_size: 'Maximum file size',
        invalidExtension: 'File is not an allowed file type: ',
    };

    this.callback = (config.callback) ? config.callback : function() {};
    this.error_callback = (config.error_callback) ? config.error_callback : function() {};
    this.validate = (config.validate) ? config.validate : function() { return true; };
    this.max_files = (config.max_files) ? parseInt(config.max_files, 10) : 0;
    this.max_upload_size = (config.max_upload_size) ? parseInt(config.max_upload_size, 10) : 0;
    this.max_file_size = (config.max_file_size) ? parseInt(config.max_file_size, 10) : 0;
    this.batch_files = (typeof config.batch_files !== 'undefined') ? !!config.batch_files : false;
    this.autoupload = (typeof config.autoupload !== 'undefined') ? !!config.autoupload : true;
    this.translations = (config.translations) ? Object.assign(defaultTranslations, config.translations) : defaultTranslations;
    this.allowedMimeTypes = (config.allowedMimeTypes) ? config.allowedMimeTypes : [];
    this.allowedFileExtensions = (config.allowedFileExtensions) ? config.allowedFileExtensions : [];

    /**
     * Can we use the advanced features
     * This will mostly just exclude IE9< I think or people with super archaic FF/Chrome/Safari
     * self invoking function
     * @prop {bool}
     */
    this.isAdvancedUpload = function() {
        var div = document.createElement('div');
        return (('draggable' in div) || ('ondragstart' in div && 'ondrop' in div))
            && 'FormData' in window
            && 'FileReader' in window;
    }();

    /**
     * Get the form
     */
    this.$form = jQuery(config.selector);
    if (this.$form.length === 0) { return false; }

    /**
     * This is a div containing the label and input[type=file]
     */
    this.$droparea = this.$form.find('.s-ui-filedrop');

    /**
     * Tracking files that have been dropped to be uploaded
     */
    this.droppedFiles = [];
    /**
     * Files batched into groups so they dont go over the max_upload_size
     */
    this.batchedFiles = [];
    /**
     * Tracking batch progress
     */
    this.batch = { current: 0, total: 0 };

    /**
     * For binding this in events until we can finally use arrow functions
     */
    var self = this;

    /**
     * The actual file input
     */
    this.$input = this.$droparea.find('input[type="file"]');
    /**
     * The label for the file input
     */
    this.$label = this.$droparea.find('label');
    /**
     * Form submit button
     */
    this.$submitbutton = this.$form.find('button[type="submit"]');
    /**
     * Progress bar
     */
    this.$progress = null;

    /**
     * Update the label to show file names
     */
    this.showFiles = function() {
        if (this.$input.length === 0) { return; }

        var fileArea = this.$droparea[0].querySelector('.s-ui-filedrop-filenames');
        var fileList = fileArea.querySelector('ul');

        if (this.isAdvancedUpload) {
            var fileItems = [];
            var total_size = 0;
            this.droppedFiles.forEach(function(file) {
                var item = document.createElement('li');
                item.innerText = file.name;
                fileItems.push(item);
                total_size += file.size;
            });

            fileList.innerHTML = '';
            if (fileItems.length === 0) {
                fileArea.classList.add('hidden');
            } else {
                fileArea.classList.remove('hidden');
                fileItems.forEach(function(li) {
                    fileList.appendChild(li);
                });
            }
            if (this.max_files > 0 && fileItems.length > this.max_files) {
                this.showError(self.max_files + ' file uploads maximum.');
            }
            if (this.batch_files === false && this.max_upload_size > 0 && total_size > this.max_upload_size) {
                this.showError('Files total ' + self.bytesToMB(total_size)
                    + ' MB which exceeds the maximum of ' + self.bytesToMB(this.max_upload_size) + ' MB at a time.');
            }
        } else {
            // only 1 file would be allowed in older browsers
            if (this.$input.val() === '') {
                fileArea.classList.add('hidden');
                fileList.innerHTML = '';
                return;
            }
            fileArea.classList.remove('hidden');
            var item = document.createElement('li');
            item.innerText = this.$input.val().split('\\').slice(-1).pop();
            fileList.appendChild(item);
            this.$label.find('.filetext').addClass('hidden');
        }
    };
    /**
     * Resets the form and files and errors
     */
    this.reset = function() {
        self.$form[0].reset();
        self.removeError();
        self.droppedFiles = [];
        self.batch.current = 0;
        self.batch.total = 0;
        self.stopProgress();
        self.showFiles();
        self.$input.removeClass('has-focus');
    };
    /**
     * Clear the files only
     */
    this.clearFiles = function() {
        self.resetFileInput();
        self.droppedFiles = [];
        self.batch.current = 0;
        self.batch.total = 0;
        self.showFiles();
    };
    /**
     * Reset the input[type=file]
     * the only way to clear a input[type=file] is to reset the whole form or remove/clone the input.
     * For this we will remove/clone, FF won't remove the value/files with a straight clone so we are cloning to a temp form,
     * resetting it, then moving the cloned input to the real form.
     */
    this.resetFileInput = function() {
        if (this.$input.length === 0) { return; }
        var $temp_form = jQuery('<form>');
        var $newinput = this.$input.clone(true).appendTo($temp_form);
        $temp_form[0].reset();
        this.$input.replaceWith($newinput);
        this.$input = $newinput;
    };
    /**
     * Show an error alert inside the drop area (good for file related errors)
     * @param {String} msg An error message
     */
    this.showError = function(msg) {
        if (this.$droparea.length === 0) { return; }
        var msgEl = document.createElement('p');
        msgEl.innerText = msg;
        if (this.$form.find('div.s-ui-filedrop-error').length > 0) {
            this.$form.find('div.s-ui-filedrop-error').append( msgEl );
            return;
        }
        var alert = document.createElement('div');
        alert.classList.add('alert');
        alert.classList.add('alert-danger');
        alert.classList.add('s-ui-filedrop-error');
        alert.setAttribute('role', 'alert');
        alert.appendChild(msgEl);
        this.$droparea.prepend(alert);
    };
    /**
     * Empty the error div, which because of the css will cause it to disappear
     */
    this.removeError = function() {
        this.$form.find('div.s-ui-filedrop-error').empty();
    };
    /**
     * Count how many files have been added to widget
     * @return {Number}
     */
    this.countFiles = function() {
        if (this.$input.length === 0) {
            return 0;
        }
        if (!this.isAdvancedUpload) {
            return (this.$input.val() !== '') ? 1 : 0;
        }
        return this.droppedFiles.length;
    };
    /**
     * Rev up the progress bar so we can start updating it
     */
    this.startProgress = function() {
        if (this.$progress === null || (this.$progress.length === 1 && this.$progress.html() === '')) {
            var existing = true;
            this.$progress = this.$form.find('div.s-ui-filedrop-progress');
            if (this.$progress.length === 0) {
                existing = false;
                this.$progress = jQuery('<div></div>').addClass('s-ui-filedrop-progress');
            }
            var $label = jQuery('<div></div>').attr({ id: 's-ui-filedrop-progresslabel' }).text('Uploading files');
            var $bar = jQuery('<div></div>')
                .addClass('s-ui-filedrop-progbar')
                .attr({
                    role: 'progressbar',
                    'aria-valuenow': '0',
                    'aria-valuemin': '0',
                    'aria-valuemax': '100',
                    'aria-labelledby': 's-ui-filedrop-progresslabel'
                });
            $bar.append( document.createElement('span') );
            this.$progress.append([$label, $bar]);
            // if the progress bar was not already in the page, we should inject it into the drop area
            if (!existing) {
                this.$droparea.prepend( this.$progress );
            }
        }
    };
    /**
     * Update the progress bar, if there is none, add it.
     * @param {number} loaded bytes uploaded
     * @param {number} total total bytes to upload
     */
    this.updateProgress = function(loaded, total) {
        var val = Math.round(loaded / total * 100);
        this.$progress.find('span:first').css('width', val + '%');
        this.$progress.find('.s-ui-filedrop-progbar').attr('aria-valuenow', val);
        if (this.batch.total > 1 && val < 50) {
            var $label = this.$progress.find('div:first');
            $label.html('Uploading file batch (' + this.batch.current + '/' + this.batch.total + ')');
        }
    };
    /**
     * Stop the progress bar (i.e. close/hide it)
     */
    this.stopProgress = function() {
        if (this.$progress !== null) {
            this.$progress.empty();
        }
    };
    /**
     * Convert bytes to MB
     * @param {Number} bytes File in bytes.
     * @return {Number} MB
     */
    this.bytesToMB = function(bytes) {
        return (parseInt(bytes, 10) / (1024 * 1024)).toFixed(1);
    };
    /**
     * Add files from a FileList to the droppedFiles array
     * checking size limitations in the process
     * @param {FileList} filelist A FileList object (Array-like)
     * @return {Boolean}
     */
    this.addFiles = function(filelist) {
        if (self.max_files > 0 && (self.countFiles() + filelist.length) > self.max_files) {
            self.showError(self.max_files + ' file uploads maximum.');
            return false;
        }
        var total_size = 0;
        self.droppedFiles.forEach(function(f) {
            total_size += f.size;
        });

        var invalid_file_indexes = [];
        for (var i = 0; i < filelist.length; i++) {
            var file = filelist[i];

            if (self.droppedFiles.length > 0) {
                //check for dupes by filename
                var dupe = false;
                self.droppedFiles.forEach(function(f) {
                    if (f.name === file.name) {
                        dupe = true;
                    }
                });
                if (dupe) {
                    invalid_file_indexes.push(i);
                    continue;
                }
            }

            if (this.allowedFileExtensions.length > 0) {
                let extension = file.name.split('.').pop().toLowerCase();

                if (this.allowedFileExtensions.indexOf(extension) === -1) {
                    self.showError(this.translations.invalidExtension + file.name);
                    invalid_file_indexes.push(i);
                    continue;
                }
            }

            // check for mime-type constraints
            if (this.allowedMimeTypes.length > 0
                && this.allowedMimeTypes.indexOf(file.type) === -1) {
                self.showError('File: ' + file.name + ' is not an allowed file type.');
                invalid_file_indexes.push(i);
                continue;
            }

            if (self.max_file_size > 0 && file.size > self.max_file_size) {
                self.showError('File: ' + file.name + ' is greater than allowed file size of '
                    + self.bytesToMB(self.max_file_size) + ' MB.');
                invalid_file_indexes.push(i); //can't edit filelist so we just have to track which files to ignore later
            } else if (self.batch_files === false && total_size + file.size > self.max_upload_size) {
                self.showError('File: ' + file.name + ' causes files to go over maximum upload size of '
                    + self.bytesToMB(self.max_upload_size) + ' MB at a time.');
                invalid_file_indexes.push(i);
            } else {
                total_size += file.size;
            }
        }
        if (self.batch_files === false && self.max_upload_size > 0 && total_size > self.max_upload_size) {
            self.showError('Files total ' + total_size + ' bytes which exceeds the maximum of '
                + self.bytesToMB(self.max_upload_size) + ' MB at a time.');
            return false;
        }

        for (var x = 0; x < filelist.length; x++) {
            if (invalid_file_indexes.indexOf(x) !== -1) { continue; }
            self.droppedFiles.push( filelist[x] );
        }
        if (self.droppedFiles.length === 0) {
            return false;
        }
        return true;
    };
    /**
     * Create an array of batched files
     * @return {Array}
     */
    this.batchFiles = function() {
        var b = [];
        var sizes = [];

        if (!this.batch_files) {
            b.push(this.droppedFiles);
            return b;
            //???
        }
        var batches = 1;
        b.push([]);
        sizes.push(0);
        this.droppedFiles.forEach(function(file) {
            var added = false;
            sizes.forEach(function(s, i) {
                if (!added && (s + file.size) < self.max_upload_size) {
                    sizes[i] = s + file.size;
                    b[i].push(file);
                    added = true;
                }
            });
            if (!added) {
                sizes.push(0);
                batches++;
                b.push([]);
                var i = batches - 1;
                sizes[i] = file.size;
                b[i].push(file);
            }
        });
        return b;
    };
    /**
     * Are we on the last batch
     * @return {Boolean}
     */
    this.isLastBatch = function() {
        return this.batch.current >= this.batch.total;
    };
    /**
     * Ajax upload event
     * For batches of files this will get called for each batch
     */
    this.ajaxUpload = function() {
        // set current batch number (so processing scripts can deal appropriately)
        self.$form.find('input[name="batch_current"]').val(self.batch.current);

        var ajaxData = new FormData(self.$form[0]);
        // Clear out empty form input... Safari hates the empty one.
        // Make sure delete is supported (it is in at least the latest Safari where we need it.)
        if (typeof ajaxData.delete === 'function') {
            ajaxData.delete(self.$input.attr('name'));
        }
        // add the current batch of files to the formdata (if no batches this is just all the files)
        self.batchedFiles[self.batch.current - 1].forEach(function(file) {
            ajaxData.append( self.$input.attr('name'), file );
        });

        jQuery.ajax({
            url: self.$form.attr('action'),
            type: self.$form.attr('method'),
            data: ajaxData,
            dataType: 'json',
            cache: false,
            crossDomain: true,
            contentType: false,
            processData: false,
            beforeSend: function() {
                // only if we have files!
                if (self.countFiles() > 0) {
                    self.startProgress();
                }
            },
            complete: function() {
                if (self.isLastBatch()) {
                    self.$form.removeClass('is-uploading');
                    self.$submitbutton.prop('disabled', false);
                    self.stopProgress();
                } else {
                    self.batch.current++;
                    // @todo update file list to show which were uploaded in the batch
                    self.ajaxUpload();
                }
            },
            success: function(data) {
                self.callback(data, self);
            },
            xhr: function() {
                // get the native XmlHttpRequest object
                var xhr = jQuery.ajaxSettings.xhr();
                if (self.countFiles() > 0) {
                    // doing this causes CORS requests to preflight
                    xhr.upload.onprogress = function(e) {
                        self.updateProgress(e.loaded, e.total);
                    };
                }
                return xhr;
            }
        }).fail(function(jqxhr) {
            self.error_callback(jqxhr, self);
        });
    };

    /**
     * If available add the drag/drop event handlers
     */
    if (this.isAdvancedUpload && this.$input.length > 0) {
        this.$droparea.addClass('has-advanced-upload');

        // inject inputs for batch file data if appropriate
        if (this.batch_files) {
            var $input1 = jQuery('<input />').attr({
                type: 'hidden',
                name: 'batch_current'
            }).val('0');
            var $input2 = jQuery('<input />').attr({
                type: 'hidden',
                name: 'batch_total'
            }).val('0');
            this.$form.prepend([$input1, $input2]);
        }

        this.$droparea.on('drag dragstart dragend dragover dragenter dragleave drop', function(e) {
            e.preventDefault();
            e.stopPropagation();
        })
            .on('dragover dragenter', function() {
                self.$droparea.addClass('is-dragover');
            })
            .on('dragleave dragend drop', function() {
                self.$droparea.removeClass('is-dragover');
            })
            .on('drop', function(e) {
                var adding = self.addFiles(e.originalEvent.dataTransfer.files);
                self.showFiles();
                if (adding === true && self.autoupload) {
                    self.$form.submit();
                }

            }).on('click', function(e) {
                // delegate for various functions
                var tags = ['A', 'I', 'SPAN', 'B', 'STRONG', 'BUTTON'];
                var tag = e.target.tagName;
                //links and possible children of links
                if (tags.indexOf(tag) !== -1) {
                    var $link = jQuery(e.target).closest('a, button');
                    if ($link.hasClass('s-ui-filedrop-clear')) {
                        // clear files button
                        self.clearFiles();
                        self.removeError();
                    }
                }
            });
    }

    if (!this.isAdvancedUpload) {
        this.$input.remove();
        this.$droparea.remove();
    }

    /**
     * For when files are added using the normal input
     * also a class to help with focus management for keyboard users
     */
    if (this.$input.length > 0) {
        this.$input.on('change', function(e) {
            if (e.target.files) {
                if (self.isAdvancedUpload) {
                    var adding = self.addFiles(e.target.files);
                    self.resetFileInput();
                    if (adding === true && self.autoupload) {
                        self.$form.submit();
                    }
                }
                self.$input.removeClass('has-focus');
                self.showFiles();
            }
        })
            .on('focus', function(e) {
                e.target.classList.add('has-focus');
            })
            .on('blur', function(e) {
                e.target.classList.remove('has-focus');
            });

        // add a warning about max files size if the translation has been included (?)
        if (this.translations.max_file_size) {
            var warning = document.createElement('p');
            warning.innerHTML = this.translations.max_file_size + ': ' + this.bytesToMB(this.max_file_size) + ' MB';
            this.$label.append(warning);
        }
    }

    /**
     * Form submit
     */
    this.$form.on('submit', function(e) {
        // don't preventdefault here as the legacy ajax support requires submitting the form
        if (self.$form.hasClass('is-uploading')) {
            e.preventDefault();
            return;
        }

        self.$form.removeClass('is-error');
        self.removeError();

        if (self.max_files > 0 && self.countFiles() > self.max_files) {
            self.showError(self.max_files + ' file uploads maximum.');
            e.preventDefault();
            return;
        }

        if (self.validate(self) === false) {
            self.$form.addClass('is-error');
            e.preventDefault();
            return;
        }

        self.$form.addClass('is-uploading');
        self.$submitbutton.prop('disabled', true);

        if (self.isAdvancedUpload) {
            e.preventDefault();
            // setup batch file
            self.batch.current = 1;
            self.batchedFiles = self.batchFiles();
            self.batch.total = self.batchedFiles.length;

            self.$form.find('input[name="batch_total"]').val(self.batch.total);

            //this will iterate as necessary over the batches
            self.ajaxUpload();
        } else {
            // ajax no files for legacy
            e.preventDefault();

            jQuery.ajax({
                url: self.$form.attr('action'),
                type: self.$form.attr('method'),
                data: self.$form.serialize(),
                dataType: 'json',
                complete: function() {
                    self.$form.removeClass('is-uploading');
                    self.$submitbutton.prop('disabled', false);
                },
                success: function(data) {
                    self.callback(data, self);
                }
            }).fail(function(jqxhr) {
                self.error_callback(jqxhr, self);
            });
        }
    });
};

/*
    Example usage:

    You must start with a form with method="POST" and enctype="multipart/form-data"
    the form's action attribute should be set to the url you want to send the form/file data to

    The file area itself should be a div.s-ui-filedrop containing an input[type=file] and a label (in that order). It's also best to include a "clear file" button.s-ui-filedrop-clear

    Example:

    <div class="form-group s-ui-filedrop">
        <input type="file" name="file_uploads[]" id="file_uploads" value="" class="sr-only" multiple />
        <label for="file_uploads" class="btn btn-default"><div><i class="fa fa-upload fa-3x"></i></div><span class="filetext"><strong>Choose a file</strong><span class="s-ui-filedrop-dragtext"> or drag it here</span>.</span></label>
        <div class="s-ui-filedrop-filenames hidden"><strong>Selected Files:</strong><ul></ul></div>
        <button type="button" class="btn btn-default btn-xs s-ui-filedrop-clear">Clear Files</button>
    </div>

    Replace "file_uploads" as appopriate for your processing script.
    The FA icon can be changed or removed.
    The text can be changed but the classes should remain the same.
    The clear button is optional, but allows for clearing the files that have been dropped in or selected via the input.
    If you want the progress to appear elsewhere on your form just add a div.s-ui-filedrop-progress that will get used to show the progress bar. It needs to be inside the form though.

    Instantiate with:

    var fileform = new springSpace.sui.filedrop({
        selector: '#someform', // selector for the form,
        max_files: 5, // total files that can be uploaded at a time
        max_upload_size: 0, // max TOTAL upload size in bytes (usually an nginx/php limitation), if using batch_requests, this is the maximum size of each batch, make sure this is slightly smaller than the nginx/php settings as this code is only comparing to the files not any other content sent with the request
        max_file_size: 0, // max single file size in bytes (usually a php limitation)
        allowedMimeTypes: ['image/jpeg', 'image/gif', 'image/png'], // limit types of uploads. Leave unset to allow any type.
        batch_files: true, // if multiple files go over the max_upload_size (but are individually under the max_File_size) then this will cause a series of ajax upload events to occur. WARNING: if you do this you must make sure your processing scripts and callbacks are accounting for multiple form submissions.
        callback: function(data) {
            // do some processing with the data returned from the script.
            // 'this' will reference the s-ui-filedrop object, unless you pass a bound function in which case the s-ui-filedrop object will be passed as the second argument to the callback.
            // data will be the JSON parsed response from the server
            // s-ui-filedrop object will be passed as the second argument
            // NOTE: If using batch uploads this callback MAY be called multiple times. Use isLastBatch() on the s-ui-filedrop object to know if this is the final request/upload
            //
        },
        error_callback: function(jqxhr) {
            // optional
            // this is called as the argument for jQuery ajax fail event
            // so it's when the server doesnt return a 200 response
            // jqxhr object is first argument
            // s-ui-filedrop object will be passed as the second argument
            // you can call reset() on the s-ui-filedrop object to clear the form and all files.
            // NOTE: If using batch uploads this callback MAY be called multiple times. Use isLastBatch() on the s-ui-filedrop object to know if this is the final request/upload
        },
        validate: function() {
            // optional
            // this is called before the ajax event is started
            // return false from this function to stop the ajax event from starting (i.e. fail validation)
            // the s-ui-filedrop object will be passed as the first argument to the validate function.
            // throw file errors with showError(msg) on the s-ui-filedrop object
            // for batch uploads this is only called before any of the ajax requests start. If you want to validate files in some custom way use the droppedFiles array of File items on the s-ui-filedrop object
        }
    });

    NOTE Batch uploads:
    When batch uploads are enabled the form will POST batch_current and batch_total values along with other form content. You can use this to know if there will be batches of the same form submitted

    NOTE Crossdomain Usage:
    Using CORS you can do crossdomain file uploads, but be aware that the progress bar code will force the a preflight check on the CORS request. The preflight is an OPTIONS request to the url you only need to return a 200 code, your normal headers, and your "Access-Control-Allow-Origin" header. That will let the browser know it is ok to send the real request. (So in dev tools Networking you will see two requests to the submit url.

*/
